class DiscountAppliedPopup extends HTMLElement {
  constructor() {
    super();
    this.discountCode = null; // Placeholder for discount code
    this.popup = null; // Reference to the popup element
  }

  connectedCallback() {
    this.initPopup();
  }

  initPopup() {
    this.discountCode = CookiesHelper.get('discount_code');
    this.closedPopup = CookiesHelper.get('closed_discount_popup');

    if (this.closedPopup === this.discountCode) {
      this.remove();
      return;
    }

    if (this.discountCode) {
      this.showPopup();
    }
  }

  showPopup() {
    this.popup = this.querySelector('.discount-applied-popup');
    if (this.popup) {
      // Insert the discount code dynamically into the popup
      const couponApplied = this.popup.querySelector('[data-coupon-applied]');
      const discountData = window.__d_metafields_data;

      if (discountData) {
        const discount = discountData.find((item) => item.title === this.discountCode.replace('+', ' '));
        if (discount) {
          const currencySymbol = Shopify.currency._symbol;

          const discountAmountEl = document.createElement('p');
          discountAmountEl.style.fontSize = '2em';
          discountAmountEl.style.fontWeight = 'normal';
          discountAmountEl.style.lineHeight = '1';
          discountAmountEl.textContent = discount['fixed']
            ? `${currencySymbol}${(discount.value * Shopify.currency.rate).toFixed(2)}`
            : `${discount.value}%`;

          if (!couponApplied) return;
          couponApplied.innerHTML = discountAmountEl.outerHTML;

        } else if (couponApplied) {
          couponApplied.textContent = this.discountCode.replace('+', ' ');
        }
      }

      // Attach event listener for the "Shop now" button
      this.popup.querySelectorAll('[data-close-popup]').forEach((button) => {
        button.addEventListener('click', this.closePopup.bind(this));
      });

      // Attach event listener for the "Close" if clicked outside the popup
      this.popup.addEventListener('click', (event) => {
        if (event.target === this.popup) {
          this.closePopup();
        }
      });

      // Display the popup
      this.popup.hidden = false;
    }
  }

  closePopup() {
    if (this.popup) {
      this.popup.hidden = true;

      // Set the "popup closed" cookie
      CookiesHelper.set('closed_discount_popup', this.discountCode, { expires: 7 }); // Cookie expires in 7 days
    }
  }
}

customElements.define('discount-applied-popup', DiscountAppliedPopup);